import * as squel from 'safe-squel';
// The purpose of this package is to turn on squel's auto-quoting and set default characters that work with Presto.
// We needed a single place to set them once. All squel references should be through this module.
squel.cls.DefaultQueryBuilderOptions = {
    ...squel.cls.DefaultQueryBuilderOptions,
    autoQuoteFieldNames: true,
    autoQuoteTableNames: true,
    autoQuoteAliasNames: true,
    fieldAliasQuoteCharacter: '"',
    nameQuoteCharacter: '"',
    tableAliasQuoteCharacter: '"'
};
export { squel };
//# sourceMappingURL=squel.js.map